import React from 'react';
import {FormFieldProps} from '../../../@types/components/Form';
import {IEmptyModel} from '../../../@interfaces/IEmptyModel';

export type NestedListFieldWidgetContext<Model extends IEmptyModel = IEmptyModel> = FormFieldProps<Model>;

export const NestedListFieldWidgetContext = React.createContext<NestedListFieldWidgetContext | null>(null);
